export class SetActiveAppListProjectsTabAction {
    public static readonly type = "[Projects] Set App list project active tab";

    constructor(public payload: number) {}
}
